/* eslint-disable no-nested-ternary */
import React, { } from 'react';
import * as echarts from 'echarts';
import classNames from 'classnames';
import { IMetricsTrendChartProps } from '@/pages/dashboard/components/MetricsTrendChart/types';
import MetricsTrendChart from '@/pages/dashboard/components/MetricsTrendChart';
import { xAxisHighLight } from '@/pages/dashboard/components/Chart/_config/plug';

import './index.scss';

const MetricsCardTrendChart: React.FC<IMetricsTrendChartProps> = (props) => {
  const {
    className,
    style,
    metricData,
    loading,
    error,
    filterVal,
    xAxisLabelFormat, // x轴展示自定义
    componentMetrics,
    height = 75,
    setOtherConfigFunc,
    showConfig = {
      showLineChart: true,
      showBubbleTitle: true,
    },
    isLeftCard = true,
    isRightCard = false,
    isOnlyChart = true,
    ...restProps
  } = props;
  
  const { timeType = 'Day' } = filterVal || {};

  const getCardChart = (opt: any, config: {timeType: string;}) => {
    const { timeType = 'Day' } = config;
    opt.yAxis.position = 'right';
    opt.yAxis.splitLine.show = false;
    opt.yAxis.splitNumber = 2;
    opt.xAxis[0].axisTick.show = false;
    opt.xAxis[0].axisLine.show = false;
    opt.xAxis[0].axisLabel.formatter = (param: string) => timeType === 'Month' ? param?.slice(5, 7) : param?.slice(-2);
    return opt;
  };

  const configFunc = (option: any) => {
    let opt = getCardChart(option, { timeType });
    opt.series = opt?.series?.map((item: any, i: number) => ({
      ...item,
      areaStyle: {
        opacity: 0.25,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: i === 0 ? '#5086F3' : '#69D19C'
          },
          {
            offset: 1,
            color: '#FFF'
          },
        ])
      },
      emphasis: {
        focus: 'series'
      },
    }));
    opt = xAxisHighLight(opt, {
      lineStyle: {
        // 之前的代码没有配置颜色，故这里使用echart默认色，防止被经分公共逻辑覆盖
        color: '#000',
        // 之前的代码没有配置颜色，估这里使用echart默认线条宽度，防止被经分公共逻辑覆盖
        width: 1,
        type: 'solid'
      },
      formatter: (params: any) => params?.value?.slice(-2),
      symbolSize: 8,
      fontSize: 11,
    });
    opt.grid = {
      x: 5,
      y: 12,
      x2: 2,
      y2: 0,
      containLabel: true
    };
    // 设计稿大小是11
    opt.legend.show = false;
    opt.xAxis[0].axisLabel.fontSize = 11;
    opt.xAxis[0].axisLabel.color = '#BBBDCB';
    opt.yAxis.axisLabel.fontSize = 11;
    opt.yAxis.axisLabel.color = '#BBBDCB';
    opt.tooltip.confine = false; // 浮窗不限制在图表区域
    opt.tooltip.axisPointer.label.padding = [5, 1, 0, 1];
    opt.tooltip.backgroundColor = "rgba(0, 0, 0, 1)";
    opt.tooltip.appendToBody = true;
    //     opt.tooltip.formatter = (params) => {
    //       console.log("** timeType", timeType);
    //       const time = moment(params?.[0]?.axisValue).format(timeType === 'Month' ? 'YYYY-MM' : 'YYYY-MM-DD');
    //
    //       let html = `<div class="dbl-trend-chart-tooltip">
    //         <div class='dbl-chart-tooltip-row'>
    // <p class='dbl-chart-tooltip-col-left'>${time}</p>
    // <p class='dbl-chart-tooltip-col-right'>${props.bubbleTitleCn || ''}</p>
    // </div>
    // `;
    //       console.log("** ddwwww", componentMetrics?.[0]);
    //       const { type, decimal } = componentMetrics?.[0]?.formatRule || {};
    //       params.forEach(param => {
    //         const value = formatDisplayValue({
    //           value: param.value,
    //           isPercent: false,
    //           accuracy: decimal || 0,
    //           unit: type || 'bmk'
    //         });
    //         html += `<div class='dbl-chart-tooltip-row'>
    // <p class='dbl-chart-tooltip-col-left'>${param.marker}${param.seriesName}</p>
    // <p class='dbl-chart-tooltip-col-right value'>${value}</p>
    // </div>`;
    //       });
    //       html += '</div>';
    //       return html;
    //     };
    opt.padding = 0;
    // 最左侧卡片
    if (isLeftCard) {
      opt.tooltip.position = function (point: number[], params: any, dom: any, rect: any, size: { viewSize: number[]; contentSize: number[]; }) {
        // 获取 tooltip 的宽度和高度
        const tooltipWidth = size.contentSize[0];
        // 计算初始 tooltip 的 x 和 y 坐标
        let x = point[0];
        const y = point[1] - 100;

        // 如果 tooltip 的左侧超过图表左侧，则将其对齐方式改为右侧
        if (x - tooltipWidth < 0) {
          x = point[0];
        } else {
          x = point[0] - tooltipWidth;
        }
        return [x, y];
      };
    }
    // 最右侧卡片
    if (isRightCard) {
      opt.tooltip.position = 'left';
    };
    return opt;
  };


  return <div className={classNames('dbd-metrics-card__flex', className)} style={style}>
    <MetricsTrendChart
      metricData={metricData}
      componentMetrics={componentMetrics}
      loading={loading}
      error={error}
      filterVal={filterVal}
      showConfig={showConfig}
      setOtherConfigFunc={configFunc}
      height={height}
      isOnlyChart={isOnlyChart}
      {...restProps}
    />
  </div>;
};

export default MetricsCardTrendChart;